import { render } from "./ModalAlerts.vue?vue&type=template&id=02a278b9"
import script from "./ModalAlerts.vue?vue&type=script&lang=js"
export * from "./ModalAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__